<template>
    <div style="width:100%;min-height:800px;min-width:1000px;margin: 0px 20px">
        <br/>
     <Row><Col span="12" offset="10"><div class="myTitle" >数据检索</div></Col></Row>
    <br>
				<Form ref="formValidate" :model="formValidate"  :label-width="110">
					<Row>
							<Col span="10">
								<FormItem label="检索时间：" >
									<ul class='termul'>
										<li v-for="(item,index) in timeList" :key="index" :class="timeFlag==index?'choosed':'choosed1'" @click="chooseTime(index)"> {{item}}</li>
									</ul>
									<span v-show="showTime">
										<DatePicker type="datetime" placeholder="开始时间"  style="width:100px" :options="options"
										v-model="formValidate.startDate" @on-change="formValidate.startDate=$event" >
									</DatePicker>-
										<DatePicker type="datetime" placeholder="结束时间"  style="width:100px" :options="options"
										v-model="formValidate.endDate"   @on-change="formValidate.endDate=$event" ></DatePicker>
									</span>
								</FormItem>
							</Col>
							<Col span="10">
								<FormItem label="信息排序:" >
									<ul class='termul'>
										<li v-for="(item,index) in infoList" :key="index" :class="infoFlag==index?'choosed':'choosed1'" @click="chooseInfo(index)"> {{item}}</li>
									</ul>
								</FormItem>
							</Col>
						</Row>
						<Row>
							<Col span="10">
								<FormItem label="关键词:" prop="keyword">
									<Input v-model="formValidate.keyword"  placeholder="关键词" style="width:250px;"></Input>
									<span style="color:red;font-size:8px;"></span>
								</FormItem>
							</Col>
							<Col span="10">
								<FormItem label="匹配方式:" >
									<ul class='termul'>
										<li v-for="(item,index) in matchList" :key="index" :class="matchFlag==index?'choosed':'choosed1'" @click="chooseMatch(index)"> {{item}}</li>
									</ul>
								</FormItem>
							</Col>							
						</Row>
						<Row>
							<Col span="6" offset=9>
							<span @click="moreShow" v-show="!otherShow" style="color:#3DC24B">显示更多筛选项
									<svg class="icon" aria-hidden="true" style="font-size: 16px;color:#3DC24B">
										<use xlink:href="#icon-jiantoudown"></use></svg>
							</span>
							</Col>
						</Row>						
						<div v-show="otherShow">
						<Row>
							<Col span="11">
								<FormItem label="价格区间:" prop="startprice">
									<InputNumber  v-model="formValidate.startprice"  placeholder="价格" style="width:80px;"></InputNumber >
									~
									<InputNumber  v-model="formValidate.endprice"  placeholder="价格" style="width:80px;"></InputNumber >
								</FormItem>								
							</Col>
						<Col span="10">
								<FormItem label="只看省内:" prop="inProvince" >
									<Checkbox v-model="formValidate.inProvince" ></Checkbox>
								</FormItem>
							</Col>
						</Row>						
						<Row>
							<Col span="20">
								<FormItem label="检索范围" prop="busiarea" >
								<!--	<CheckboxGroup v-model="formValidate.huntingZone"  -->
								 <Tabs value="name1" >
									<TabPane label="旅游" name="name1" icon="md-jet">
									 <Checkbox
											:indeterminate="indeterminate"
											:value="checkAll"
											 @click.prevent.native="handleCheckTravelAll">全选</Checkbox>
									 <CheckboxGroup v-model="formValidate.checkAllGroup"  >
										<Checkbox v-for="(item,index) in travelList" :key="1+index" 
										:label="item" border ></Checkbox>
									   </CheckboxGroup>
										</TabPane>
									<TabPane label="票务" name="name2" icon="ios-paper">
										 <Checkbox
											:indeterminate="iteTicket"
											:value="checkAllTicket"
											 @click.prevent.native="handleCheckTicketAll">全选</Checkbox>
									      <CheckboxGroup v-model="formValidate.checkAllTicketGroup"  >
										    <Checkbox v-for="(item,index) in ticketList" :key="100+index" :label="item" border>
											</Checkbox>
										  </CheckboxGroup>
									</TabPane>
									<TabPane label="文化" name="name4" icon="ios-school">
									  <Checkbox
											:indeterminate="iteCulture"
											:value="checkAllCulture"
											 @click.prevent.native="handleCheckCultureAll">全选</Checkbox>
									      <CheckboxGroup v-model="formValidate.checkAllCultureGroup"  >
									     	<Checkbox v-for="(item,index) in cultureList" :key="500+index" :label="item" border></Checkbox>
									      </CheckboxGroup>
									 </TabPane>
									<TabPane label="舆情" name="name3" icon="ios-thunderstorm">
									 <Checkbox
											:indeterminate="iteSentimment"
											:value="checkAllSentimment"
											 @click.prevent.native="handleCheckSentimmentAll">全选</Checkbox>
									      <CheckboxGroup v-model="formValidate.checkAllSentimmentGroup"  >
										     <Checkbox v-for="(item,index) in sentimmentList" :key="1000+index" :label="item" border></Checkbox>
										  </CheckboxGroup>
									</TabPane>
								</Tabs>									
							      
								</FormItem>								
							</Col>
						</Row>
						<Row>
							<Col span="6" offset=9>
							<span @click="otherShow=false" style="color:#3DC24B">收起  
								<svg class="icon" aria-hidden="true" style="font-size: 16px;color:#3DC24B">
									<use xlink:href="#icon-shangjiantou"></use></svg></span>
							</Col>
						</Row>
						</div>
				</Form>			
             <Row>
				<Col span="8">&nbsp;</Col>
                <Col span="8"> 
                   <Button type="primary"  @click="handleSubmit('find')">查询</Button>&nbsp;&nbsp;&nbsp;
				   <Button  @click="openForm('formValidate')">保存任务</Button>
				</Col>
          	</Row>
			  <br/>
	    <Row v-show="listData.length>0">
            <Col span="24">
			   <Row>
				 <Col span="5" offset=13> 
                   	<Input v-model="keytitle"  placeholder="筛选" style="width:250px;" search enter-button  @on-search="searchInfo"></Input>
				</Col>
				<Col span="1" >&nbsp; </Col>
                <Col span="2" > 
                   <Button type="success"  @click="exportExcel('export')">数据导出</Button>&nbsp;&nbsp;&nbsp;
				</Col>
          	  </Row>
			  <br/>
             <Row>
                <Col span="24">
                        <Table :loading="loading" @on-selection-change="selectRow"
                               border ref="table" stripe :columns="columns4" :data="listData">
                            <template slot-scope="{ row }" slot="name">
                                <strong>{{ row.name }}</strong>
                            </template>
                            <template slot-scope="{ row }" slot="action">
								<Button type="info" size="small" @click="addclue(row)"  >加入线索</Button>
							</template>
                        </Table>
                 </Col>
            </Row>
            <Row>
                <Col span="24">
                	<div>
                        <Footer>
                            <Page show-sizer show-total :total="rowCount" :current="current"
                                  :page-size="pageSize"  @on-change="changePage"
                                  @on-page-size-change="changeSize" />
                        </Footer>
                    </div>
            	</Col>
            </Row>
        </Col>
    </Row>
	<taskEdit ref="taskEdit"></taskEdit>
    </div>
</template>
<script>
import taskEdit from '@/pages/platform/task/taskEdit';
 import  date   from "@/utils/date";
 import  downloadTemplate   from "@/utils/downloadFile";
 import '../../../assets/icons/iconfont/iconfont.css';
 import '../../../assets/icons/iconfont/iconfont.js';
 import moment from 'moment'
    export default {
	  components: {
            taskEdit
       },
         data() {
             return {
				 loading: true,
				 keytitle:'',
				 listData: [],
				 pageSize: 10,
                 current: 1,
                 rowCount: 0,
				 otherShow:false,
				 travelList:[],
				 indeterminate: false,
                 checkAll: false,
				 ticketList:[],
				 iteTicket: false,
				 iteCulture: false,
				 iteSentimment: false,
                 checkAllTicket: false,
                 checkAllSentimment: false,
                 checkAllCulture: false,
				 cultureList:[],
				 sentimmentList:[],
                 formValidate: {
					startDate:date.getTime()+" 00:00:00",
					endDate:date.getTime()+" 23:59:59",
					checkAllGroup:[],
					checkAllTicketGroup:[],
					checkAllCultureGroup:[],
					checkAllSentimmentGroup:[],
				    huntingZone:[],
					inProvince:true,
					province:0,
					startprice:0,
					endprice:0,
					keyword:'',
					supplierInfo:'',
				 },
				    addKeyword:'',
				    timeList: ['今天', '2天', '3天', '7天', '自定义'],
					timeFlag: 0,
					timeValue: '今天' ,// 点击li获取的值
					showTime:false,
					options: {    //日期选择器今天之后的日期禁止选择
						disabledDate (date) {
							return date && date.valueOf() >= new Date();
						}
					},
					infoList: ['采集降序', '时间升序', '时间降序', '价格升序', '价格降序'],
					infoFlag: 0,
					infoValue: '采集降序' ,// 点击li获取的值
					matchList: ['按标题', '按内容', '按简介','按经营单位'],
					matchFlag: 0,
					matchValue: '按标题' ,// 点击li获取的值
					selectRows: [],
					columns4: [{
							type: 'index',
							title: '序号',
							width: 60,
							align: 'center',
						},
					   {
							title: '分类',
							width:100,
							key: 'category' ,
							align: 'center',
						}	,
						{
							title: '内容',
							key: 'title' ,
							align: 'center',
							render:(h,params)=>{
								let text=''
								
								text='<div>'+
								'<div style="float:left;text-align:left;"><div>'+
								'<span  style="font-size:12px;font-weight:600"><a target="+blank" href='+params.row.url+'>'+params.row.title+'</a></span> </div>';
								if(params.row.content!=''&&params.row.content!=undefined){
									text+='<div>'+ params.row.content+'</div> '
								}
								if(params.row.info!=''&&params.row.info!=undefined){
									text+='<div>'+ params.row.info+'</div>'
								}
								if(params.row.img.length>0){
									text+=' <div class="imgWrap">'
									for(let i=0;i<params.row.img.length&&i<5;i++){
										text+='<div class="imgContent" > '+
										     '<img referrer="no-referrer|origin|unsafe-url" class="" src="'+params.row.img[i]+'" style="height: 100px;"> </div>'
									}									
									text+=' </div>'
								}						
								
								text+='<div >'
								if(params.row.type!=''&&params.row.type!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe738;</i><span style="color: #2A5585;"> '+params.row.type+' &nbsp;&nbsp;</span>'   
								}
								if(params.row.minPrice!=''&&params.row.minPrice!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe695;</i><span style="color: #2A5585;"> '+params.row.minPrice+'元 &nbsp;&nbsp;</span>'   
								}
								if(params.row.supplierInfo!=''&&params.row.supplierInfo!=undefined){
									text+='  '+
									'<i class="iconfont" style="font-size: 16px;">&#xe62f;</i><span style="color: #2A5585;cursor: pointer;" onclick=toCompanyInfo("'+params.row.supplierInfo+'","'+params.index+'")> '+params.row.supplierInfo+' &nbsp;&nbsp;</span>'   
								}
								
								if(params.row.releaseTime!=''&&params.row.releaseTime!=undefined){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe74f;</i><span style="color:#2A5585"> '+params.row.releaseTime+'</span>'   
								}
								if(params.row.inProvince==0){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe62c;</i><span style="color:#2A5585"> 省外</span>'   
								}else{
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe62c;</i><span style="color:#2A5585">陕西省</span>'   
								}
								if(params.row.venue!=''&&params.row.venue!=undefined){
									text+=''+
									'<i class="iconfont" style="font-size: 16px;">&#xe73a;</i><span style="color:#2A5585"> '+params.row.venue+'</span>'   
								}
								

								text+='</div></div></div>'
								return h("div",{domProps:{
									innerHTML:`<div href=`+params.row.url+` target='_blank'>`+text+`</div>`
								}})
							}
						}, {
							title: '来源',
							width:100,
							key: 'source' ,
							align: 'center',
						},{
							title: '时间',
							width:100,
							key: 'spiderTime' ,
							align: 'center',
						},{
							title: '操作',
							width:100,
							slot: 'action',
							align: 'center',
						}
					],
             }
         },
         methods: {
			 //旅游全选、取消全选
			  handleCheckTravelAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;
                if (this.checkAll) {
                    this.formValidate.checkAllGroup = this.travelList;
                } else {
                    this.formValidate.checkAllGroup = [];
                }
            },
			//票务全选、取消全选
			  handleCheckTicketAll () {
                if (this.iteTicket) {
                    this.checkAllTicket = false;
                } else {
                    this.checkAllTicket = !this.checkAllTicket;
                }
                this.iteTicket = false;
                if (this.checkAllTicket) {
                    this.formValidate.checkAllTicketGroup = this.ticketList;
                } else {
                    this.formValidate.checkAllTicketGroup = [];
                }
            },
				//文化全选、取消全选
			  handleCheckCultureAll () {
                if (this.iteCulture) {
                    this.checkAllCulture = false;
                } else {
                    this.checkAllCulture = !this.checkAllCulture;
                }
                this.iteCulture = false;
                if (this.checkAllCulture) {
                    this.formValidate.checkAllCultureGroup = this.cultureList;
                } else {
                    this.formValidate.checkAllCultureGroup = [];
                }
            },
				//舆情全选、取消全选
			  handleCheckSentimmentAll () {
                if (this.iteSentimment) {
                    this.checkAllSentimment = false;
                } else {
                    this.checkAllSentimment = !this.checkAllSentimment;
                }
                this.iteSentimment = false;
                if (this.checkAllSentimment) {
                    this.formValidate.checkAllSentimmentGroup = this.sentimmentList;
                } else {
                    this.formValidate.checkAllSentimmentGroup = [];
                }
            },
			//添加线索
		
            addclue(item){
					  this.$Modal.confirm({
                    title: '添加线索',
                      content: `确定要将\"${item.title}\"添加到线索管理吗?`,
                    onOk: () => {
                         this.loading = true
                          let url = `/api/data/clue`
							this.req({
								url: url,
								method: 'post',
								data:{
								type:1,
								_id:item._id,
								}
							}).then(resp => {
								if(resp.data.code==200){
								this.$Message.info(resp.data.msg)
								}else{
									this.$Message.error(resp.data.msg);
									if(resp.data.msg=="缺少参数token"){
										this.$Message.error("登录过期，请重新登录");
										this.$router.push("/login");
									}
								}
								this.loading = false
							}).catch(error => {
							this.$Message.error('服务器错误:' + error)
							})
                    },
                    onCancel: () => {
                         this.loading = false
                    }
                });
                   
            },
			//设置参数
			getparams(){
				 let   _travel= this.formValidate.checkAllGroup;
				 let _ticket=this.formValidate.checkAllTicketGroup;
				 let _culter=this.formValidate.checkAllCultureGroup;
				let  _sentimment=this.formValidate.checkAllSentimmentGroup;
				let params ={
                    keyword:this.formValidate.keyword,
                    addKeyword:this.addKeyword,
					huntingZone:{
						travel:_travel,
						culter:_culter,
						ticket:_ticket,
						sentimment:_sentimment,
					},
					checkAllGroup:this.formValidate.checkAllGroup,
					checkAllTicketGroup:this.formValidate.checkAllTicketGroup,
					checkAllCultureGroup:this.formValidate.checkAllCultureGroup,
					checkAllSentimmentGroup:this.formValidate.checkAllSentimmentGroup,
					startTime:moment(this.formValidate.startDate).format('YYYY-MM-DD HH:mm:ss'),
					endTime:moment(this.formValidate.endDate).format('YYYY-MM-DD HH:mm:ss'),
					minPrice:this.formValidate.startprice,
					maxPrice:this.formValidate.endprice,
					p: this.current,
					pageSize: this.pageSize,
					inProvince:this.formValidate.province,
					sort:'',
					title:'',
					content:'',
					supplierInfo:'',
					info:'',
				}
				if(this.infoValue=='采集降序'){
					params.sort= {spiderTime:-1};
				}else if(this.infoValue=='时间升序'){
					params.sort= {releaseTime:1};
				}else if(this.infoValue=='时间降序'){
					params.sort= {releaseTime:-1};
				}else if(this.infoValue=='价格升序'){
					params.sort= {price:1};
				}else if(this.infoValue=='价格降序'){
					params.sort= {price:-1};
				}

				if(this.matchValue=='按标题'){
					params.title= 1;
				}else if(this.matchValue=='按内容'){
					params.content= 1;
				}else if(this.matchValue=='按经营单位'){
					params.supplierInfo= 1;
				}else {
					params.info= 1;
				}
				return params;
			},
			openForm() {
			   if(this.formValidate.keyword==''){
					 this.$Message.error('请输入关键词')
					 return
				}
			  let pararm=this.getparams()
              this.$refs.taskEdit.openModal('保存任务',pararm);
       
            },
             //选择检索时间
			chooseTime (index,value) {
				let t = this
				t.timeFlag = index
				if(index.toString() != ""){
                  t.timeValue = t.timeList[index]
				}else{
				   t.timeValue =value	
				}
				
				if(t.timeValue=='自定义'){
					t.showTime=true
				}else{
					t.showTime=false
					if(t.timeValue=='今天'){
                        this.formValidate.startDate=date.myGetDay(0)+"  00:00:00"
						this.formValidate.endDate=date.myGetDay(0)+ " 23:59:59"
					}else if(t.timeValue=='2天'){
                        this.formValidate.startDate=date.myGetDay(1)+"  00:00:00"
						this.formValidate.endDate=date.getTime()+ " 23:59:59"
					}else if(t.timeValue=='3天'){
                        this.formValidate.startDate=date.myGetDay(2)+"  00:00:00"
						this.formValidate.endDate=date.getTime()+ " 23:59:59"
					}else if(t.timeValue=='7天'){
                        this.formValidate.startDate=date.myGetDay(6)+"  00:00:00"
						this.formValidate.endDate=date.getTime()+ " 23:59:59"
					}
				}
           },
		    //信息排序
			chooseInfo (index) {
				let t = this
				t.infoFlag = index
				t.infoValue = t.infoList[index]
            },
			//匹配方式
			chooseMatch (index) {
				let t = this
				t.matchFlag = index
				t.matchValue = t.matchList[index]
            },
			moreShow(){
				this.otherShow=true
			},
			//检索范围
		     loadCheck(row) {
                let url = `/api/zone`
                this.req({
                    url: url,
                    method: 'get'
                }).then(resp => {
					if(resp.data.code==200){
						this.travelList=resp.data.page.travel
						this.ticketList=resp.data.page.ticket
						this.cultureList=resp.data.page.culture
						this.sentimmentList=resp.data.page.sentimment
											
						 if(row!=undefined){
						    this.formValidate.checkAllGroup =row.searchData.huntingZone.travel
							this.formValidate.checkAllTicketGroup=row.searchData.huntingZone.ticket
							this.formValidate.checkAllCultureGroup=row.searchData.huntingZone.culture
							this.formValidate.checkAllSentimmentGroup=row.searchData.huntingZone.sentimment
				         }else{
                             this.formValidate.checkAllGroup=[]  //this.travelList
							 this.formValidate.checkAllCultureGroup=[]  //this.cultureList
							 this.formValidate.checkAllSentimmentGroup=[]  //this.sentimmentList
							 this.formValidate.checkAllTicketGroup=[]  //this.ticketList
							 this.formValidate.checkAllCultureGroup = [];
						 }
						
					}else{
						this.$Message.error(resp.data.msg);
						if(resp.data.msg=="缺少参数token"){
							this.$Message.error("登录过期，请重新登录");
							this.$router.push("/login");
					    }
				   }
                   
                    this.loading = false
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
            },
			 changePage(curPage) {
                this.loading = true
                this.current = curPage
                this.handleSubmit()
            },
			changeSize(pageSize) {
                this.pageSize = pageSize
                this.loading = true
                this.handleSubmit()
            },
			 selectRow(selection) {
                this.selectRows = selection;
            },
			
			//查询
			  handleSubmit(param) {
				if(param=='find'){
					this.current=1;
				}
			    
                let url = `/api/data`
				if(this.formValidate.inProvince){
					this.formValidate.province=1
				}else{
					this.formValidate.province=0
				}
				 let   _travel= this.formValidate.checkAllGroup;
				 let _ticket=this.formValidate.checkAllTicketGroup;
				 let _culter=this.formValidate.checkAllCultureGroup;
				let  _sentimment=this.formValidate.checkAllSentimmentGroup;
				let params ={
                    keyword:this.formValidate.keyword,
                    addKeyword:this.addKeyword,
					huntingZone:{
						travel:_travel,
						culter:_culter,
						ticket:_ticket,
						sentimment:_sentimment,
					},
					startTime:moment(this.formValidate.startDate).format('YYYY-MM-DD HH:mm:ss'),
					endTime:moment(this.formValidate.endDate).format('YYYY-MM-DD HH:mm:ss'),
					minPrice:this.formValidate.startprice,
					maxPrice:this.formValidate.endprice,
					p: this.current,
					pageSize: this.pageSize,
					inProvince:this.formValidate.province,
					sort:'',
					title:'',
					content:'',
					supplierInfo:'',
					info:'',
				}
				if(this.infoValue=='采集降序'){
					params.sort= {spiderTime:-1};
				}else if(this.infoValue=='时间升序'){
					params.sort= {releaseTime:1};
				}else if(this.infoValue=='时间降序'){
					params.sort= {releaseTime:-1};
				}else if(this.infoValue=='价格升序'){
					params.sort= {price:1};
				}else if(this.infoValue=='价格降序'){
					params.sort= {price:-1};
				}

				if(this.matchValue=='按标题'){
					params.title= 1;
				}else if(this.matchValue=='按内容'){
					params.content= 1;
				}else if(this.matchValue=='按经营单位'){
					params.supplierInfo= 1;
				}else {
					params.info= 1;
				}
                this.req({
                    url: url,
                    method: 'post',
                    data:params
                }).then(resp => {
                   if(resp.data.code == 200) {
                         this.listData = resp.data.page.list;
						 this.rowCount = resp.data.page.rowCount;
						 this.currentPage = resp.data.page.p;
						 if(this.listData.length==0){
							 this.$Message.info('暂无数据')
						 }
						 
					} else {
							this.$Message.error(resp.data.msg);
							if(resp.data.msg=="缺少参数token"){
								this.$Message.error("登录过期，请重新登录");
								this.$router.push("/login");
							}
					}
	              	  this.loading = false		
					  this.addKeyword=''	
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
            },
			 
			exportExcel() {
			    
                let url = `/api/export`
				if(this.formValidate.inProvince){
					this.formValidate.province=1
				}else{
					this.formValidate.province=0
				}
		         let   _travel= this.formValidate.checkAllGroup;
				 let _ticket=this.formValidate.checkAllTicketGroup;
				 let _culter=this.formValidate.checkAllCultureGroup;
				let  _sentimment=this.formValidate.checkAllSentimmentGroup;
				let params ={
                    keyword:this.formValidate.keyword,
                    addKeyword:this.addKeyword,
					huntingZone:{
						travel:_travel,
						culter:_culter,
						ticket:_ticket,
						sentimment:_sentimment,
					},
					startTime:moment(this.formValidate.startDate).format('YYYY-MM-DD HH:mm:ss'),
					endTime:moment(this.formValidate.endDate).format('YYYY-MM-DD HH:mm:ss'),
					minPrice:this.formValidate.startprice,
					maxPrice:this.formValidate.endprice,
					p: this.current,
					pageSize: this.pageSize,
					inProvince:this.formValidate.province,
					sort:'',
					title:'',
					content:'',
					info:'',
					supplierInfo:'',
				}
				if(this.infoValue=='采集降序'){
					params.sort= {spiderTime:-1};
				}else if(this.infoValue=='时间升序'){
					params.sort= {releaseTime:1};
				}else if(this.infoValue=='时间降序'){
					params.sort= {releaseTime:-1};
				}else if(this.infoValue=='价格升序'){
					params.sort= {price:1};
				}else if(this.infoValue=='价格降序'){
					params.sort= {price:-1};
				}

				if(this.matchValue=='按标题'){
					params.title= 1;
				}else if(this.matchValue=='按内容'){
					params.content= 1;
				}else if(this.matchValue=='按经营单位'){
					params.supplierInfo= 1;
				}else {
					params.info= 1;
				}
			  
                this.req({
                    url: url,
                    method: 'post',
					responseType: "blob", // "arraybuffer",
					timeout: 3 * 60 * 1000,
                    data:params
                }).then(resp => {
                  downloadTemplate.fileDownload(resp.data, "file.csv");
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
            },
			 
            toCompanyInfo(data,index){
               this.$router.push({ path: '/home/main/company/CompanyList', query: {compay:data }})
            },
			searchInfo(){
				this.addKeyword =this.keytitle
				this.handleSubmit()
			}
			
         },
		 created(){
            let _this=this;
            window.toCompanyInfo=_this.toCompanyInfo;
        },
		 mounted() {
           
		   let row=this.$route.query.row
		    this.loadCheck(row)
		   if(row!=undefined){
                 this.formValidate.keyword=row.keyword
				 //this.formValidate.huntingZone=row.searchData.huntingZone
				 this.formValidate.checkAllGroup =row.searchData.huntingZone.travel
				 this.formValidate.checkAllTicketGroup=row.searchData.huntingZone.ticket
				 this.formValidate.checkAllCultureGroup=row.searchData.huntingZone.culture
				 this.formValidate.checkAllSentimmentGroup=row.searchData.huntingZone.sentimment
				 this.timeFlag=4
				 this.showTime=true
				 this.formValidate.startDate=row.searchData.startTime
				 this.formValidate.endDate=row.searchData.endTime
                 if(row.searchData.sort.spiderTime!=undefined&&row.searchData.sort.spiderTime==-1){
					this.infoValue='采集降序'
					this.infoFlag=0
				}
				 if(row.searchData.sort.releaseTime!=undefined&&row.searchData.sort.releaseTime==1){
					this.infoValue='时间升序'
					this.infoFlag=1
				}
				 if(row.searchData.sort.releaseTime!=undefined&&row.searchData.sort.releaseTime==-1){
					this.infoValue='时间降序'
					this.infoFlag=2
				}
				 if(row.searchData.sort.price!=undefined&&row.searchData.sort.price==1){
					this.infoValue='价格升序'
					this.infoFlag=3
				}
				 if(row.searchData.sort.price!=undefined&&row.searchData.sort.price==-1){
					this.infoValue='价格降序'
					this.infoFlag=4
				}
				 if(row.searchData.title!=undefined&&row.searchData.title==1){
                     this.matchFlag=0
					 this.matchValue='按标题'
				 }
				 if(row.searchData.content!=undefined&&row.searchData.content==1){
                     this.matchFlag=1
					 this.matchValue='按内容'
				 }
				 if(row.searchData.info!=undefined&&row.searchData.info==1){
                     this.matchFlag=2
					 this.matchValue='按简介'
				 }
				  if(row.searchData.supplierInfo!=undefined&&row.searchData.supplierInfo==1){
                     this.matchFlag=3
					 this.matchValue='按经营单位'
				 }
				 this.formValidate.startprice=row.searchData.minPrice
				 this.formValidate.endprice=row.searchData.maxPrice
				 if(row.searchData.inProvince==1){
					 this.formValidate.inProvince=true
				 }else{
                     this.formValidate.inProvince=false
				 }
				// this.handleSubmit()

		   }
        },

		 
     }
</script>
<style scoped>
    .demo-spin-icon-load{
        width :300px;
        animation: ani-demo-spin 1s linear infinite;
    }
	
	Checkbox{
		margin: 3px;
		padding: 3px;
	}
	.myTitle{
      font-size: 20px;
      font-weight: 700;
     }
 .termul,li{
     display: inline-block;
    }
  .termul li{
    margin:0px 8px;
    font-size: 0.8em;
    text-align: center;
	cursor: pointer;

  }
  .choosed{
    color: #308CEE;
  }
  .choosed1{
    color: #7c7e7e;
  }
  .home-content{
    margin-top: 10px;
    width: 100%;
   
 }   
 .content-ul{
    margin: 0;
    padding: 0;
    list-style-type: none;
    min-height: 100px;
    }
	.document-main-content {
    word-break: break-all;
    padding: 0 10px 10px;
    list-style-type: none;
    width: 100%;
    position: relative;
}
.document-main-content .doc_spliter {
    height: 1px;
    opacity: 1;
    width: 100%;
    margin-bottom: 10px;
    background: transparent;
    background-color: #f2f2f2;
}
.document-main-content .article-mainContent {
    clear: both;
    margin: 0;
    overflow: hidden;
    word-wrap: break-word;
    width: 100%;
}
.document-main-content .article-mainContent .titleDiv {
    clear: both;
    font-size: 16px;
    width: 100%;
    line-height: 22px;
    max-height: 44px;
    margin-bottom: 3px;
    word-break: break-word;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    color: #1190b7;
}
.article-mainContent .innerContent {
    clear: both;
    float: left;
    width: 100%;
    cursor: pointer;
}
.innerContent .summary {
    line-height: 22px;
    max-height: 76px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    font-size:14px;
}
.document-main-content .imgWrap {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: stretch;
    align-items: stretch;
    width: 100%;
    height: 100px;
    margin: 10px 0;
    overflow: hidden;
    max-height: 100px;
}
 .imgWrap .imgContent {
    -ms-flex: none;
    flex: none;
    width: 150px;
    height: 100%;
    margin: 0 2px;
    overflow: hidden;
}
 .article-mainContent .infos {
    font-size: 12px;
    clear: both;
    height: 22px;
    line-height: 22px;
    margin: 10px 0 3px;
    overflow: hidden;
    color: #989898;
	float: left;
}
 .document-bottom-btn-content {
    float:right;
    width: 20%;
	margin-right: 5%;
    height: 100%;
    font-size: 16px;
	text-align: left;
}
.document-bottom-btn-content  .btn-item{
    float: right;
    margin: 2px 10px;
    cursor: pointer;
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    margin-left: 3px;
    -ms-flex: none;
    flex: none;
    color: #a4b2c9;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

</style>


// WEBPACK FOOTER //
// src/pages/platform/task/TaskAdd.vue